/**
 * Created by andrey on 08.08.2025
 */

cc.DelayTime = function (duration) {
    cc.ActionInterval.call(this, duration);
};

cc.DelayTime.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.DelayTime,

    update: function () {},

    _autoFinalize: function () {}
});

cc.delayTime = (duration) => new cc.DelayTime(duration);
